import styled from 'styled-components';

const UploadWrapperS = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--height-gap);
  margin: 0 1rem;
`;

export default UploadWrapperS;
